export default __webpack_public_path__ + "static/media/shop-slide-01.0ba07288.jpg";